'use client';

import useSWRImmutable from 'swr/immutable';
import { getAbTestingData } from '@/api/public';
import { useStore } from '@/providers/app-store-provider';
import logger from '@/utils/client-logger';
import { env } from '@/utils/env';
import { LULING_CHAT_EXPERIMENT_KEY } from './customer-service-experiment';

/** 查询期间老客服仍可用；沿用公共请求超时，不能把有效慢响应提前锁为控制组。 */
async function fetchLulingChatGroup(): Promise<1 | 2> {
  try {
    const response = await getAbTestingData({ param_name: LULING_CHAT_EXPERIMENT_KEY });
    const value = response?.code === 200 ? response.data?.strategy_variable : undefined;
    return value === 2 || value === '2' ? 2 : 1;
  } catch (error) {
    logger.warn('Failed to get Luling chat experiment group', error);
    return 1;
  }
}

/** 在进站身份与币种准备后分组，复用既有神策身份请求链路，不在页面间重新随机。 */
export function useLulingChatExperiment(enabled: boolean): 1 | 2 {
  const token = useStore((state) => state.token);
  const currency = useStore((state) => state.currency?.name);
  const ready = useStore(
    (state) => state.clientTokenReady && state.currencyReady && !state.inAppH5,
  );
  const active = enabled && ready && (env.NEXT_PUBLIC_SITE_NAME || 'us') === 'us';
  const { data } = useSWRImmutable(
    active ? [LULING_CHAT_EXPERIMENT_KEY, token, currency] : null,
    fetchLulingChatGroup,
    { shouldRetryOnError: false, keepPreviousData: false },
  );
  return active && data === 2 ? 2 : 1;
}
